'use strict';

// load jQuery Slinky (for drilldown menu, using a custom fork of jQuery Slinky because the original was not customizable enough)
basecoat.jQuerySlinky = require('jquery-slinky');

+function ($) {

  $.mobileMenu = function (option) {
    var open = option === 'show';
    open = option === 'toggle' ? undefined : option;
    $('html').toggleClass('mobile-menu-open', open);
  };

  $(document)
  // open the mobile-menu
  .on('click.bc.mobileMenu', '[data-toggle="mobile-menu"]', function (e) {
    e.preventDefault();
    $.mobileMenu('toggle');
  })
  // click anywhere outside to close the menu
  .on('click.bc.mobileMenu touchstart.bc.mobileMenu', '.mobile-menu-layout', function (e) {
    if ($(e.target).hasClass('mobile-menu-layout')) {
      $.mobileMenu('hide');
      // $('html').removeClass('mobile-menu-open');
    }
  })
  // close the menu when navigating to another page
  .on('click.bc.mobileMenu', '.mobile-menu nav a:not(".next, .back")', function () {
    // $('html').removeClass('mobile-menu-open');
    $.mobileMenu('hide');
  });

  basecoat.init.mobileMenu = function () {
    if ($('.mobile-menu .drilldown:not(.slinky-menu)').length > 0) {
      // determine which page of the menu should be open on load
      var $currentLevel = $('.mobile-menu .drilldown ul:first');
      var $activeItem = $('.mobile-menu .drilldown li.active');
      if ($activeItem.find('ul').length > 0) {
        $currentLevel = $activeItem.find('ul:first');
      } else if ($activeItem.closest('ul').length > 0) {
        $currentLevel = $activeItem.closest('ul');
      }

      // drilldown menu
      $('.mobile-menu .drilldown').slinky({
        activeClass: 'current-level', // Class that's applied to the current menu level `<ul>`
        headerClass: 'heading', // Class name for the container for the back button and heading
        headingTag: '<h2 class="title">', // Tag that contains the heading
        backFirst: true, // Optionally append the back button before the heading instead of after
        label: 'Back', // Label for the back button. Pass true to use the link's own label
        title: true, // Pass true to show title of current menu level
        speed: 300, // Animation speed in milliseconds
        resize: true // Resize menu height to match content on navigation
      }).jump($currentLevel);

      // add active class to all parent menu items (showing the route, like a breadcrumb)
      $('.mobile-menu nav li.active').parents('ul > li').addClass('active');
    }
  };

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/mobile-menu.js
// module id = 8
// module chunks = 0